import { store } from '@betacrew/jars-flux';
import { all, put, takeLeading } from 'redux-saga/effects';
import { componentKey, setUploadedFile, setValidationStatus } from './BulkUploadSlice';
import PayerDataService from '../../../../../services/PayerDataService';
import { addNotifications } from '../../../toaster/ToasterPortalSlice';
import { PAGE_STATE } from '../../../constants/constants';
import { TOASTER_VARIANT } from '../../../../components/toast/constants';
import { setLoadingState, setMethodType } from '../AddPayerSlice';
import General from '../../../../../libs/utility/General';
import { ADD_PAYER_LOADING_STATES } from '../constant';


export const { uploadSheet, getTemplate, validateSheetRecords, downloadErroReport } = {
    uploadSheet: (payload) => {
        return {
            type: "NEW/UPLOAD_SHEET",
            payload
        }
    },
    getTemplate: (payload) => {
        return {
            type: "NEW/DOWNLOAD_TEMPLATE",
            payload
        }
    },
    validateSheetRecords: (payload) => {
        return {
            type: "NEW/VALIDATE_SHEET_RECORDS",
            payload
        }
    },
    downloadErroReport: (payload) => {
        return {
            type: "NEW/DOWNLOAD_ERROR_REPORT",
            payload
        }
    }
}

function* getTemplateAsync(action) {

    try {
        yield put(setLoadingState({ state: ADD_PAYER_LOADING_STATES.GET_TEMPLATE_LOADING }))

        const response = yield PayerDataService.getTemplate();

        if (response?.data.Status) {
            const { Base64, Name } = response?.data?.Data;
            General.downloadFile(Base64, Name);
            yield put(addNotifications({ heading: "Template Downloaded", message: response?.data?.Message, variant: TOASTER_VARIANT.SUCCESS }));
        } else {
            yield put(addNotifications({ heading: "Something went wrong, failed to download the template", message: response?.data?.Message }));
        }

    } catch (error) {
        yield put(addNotifications({ heading: "Failed to download the template", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: ADD_PAYER_LOADING_STATES.GET_TEMPLATE_READY }))
    }

}

function* uploadSheetAsync(action) {

    try {
        yield put(setLoadingState({ state: ADD_PAYER_LOADING_STATES.UPLOAD_FILE_LOADING }))
        const uploadedFile = action.payload;

        const formData = new FormData();
        formData.append("files", uploadedFile);

        const response = yield PayerDataService.uploadSheet(formData);

        if (response?.data.Status) {
            yield put(addNotifications({ heading: "File Uploaded Successfully", message: response?.data?.Message, variant: TOASTER_VARIANT.SUCCESS }));
        } else {
            yield put(addNotifications({ heading: "Something went wrong, file not uploaded successfully", message: response?.data?.Message }));
        }

    } catch (error) {
        yield put(addNotifications({ heading: "Failed to upload a file", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: ADD_PAYER_LOADING_STATES.UPLOAD_FILE_READY }))
    }

}

function* validateSheetRecordsAsync(action) {

    try {
        yield put(setLoadingState({ state: ADD_PAYER_LOADING_STATES.VALIDATE_SHEET_RECORD_LOADING }))

        const response = yield PayerDataService.validateSheetRecords();
        const { Status, Message, Data } = response?.data;

        const totalRecord = isNaN(Data) ? General.convertObjStringToObject(Data)?.total : Data
        if (Status) {
            yield put(setValidationStatus({
                successfullyAddedPayers: parseInt(totalRecord),
                payersWithErrors: 0,
                success: Status ? true : false,
                message: Message
            }))

        } else {
            if(Data){
                const { errorCount } = General.convertObjStringToObject(Data)
    
                const status = Status ? true : false;
    
                if (errorCount < 10) {
                    yield put(addNotifications({ heading: "Something went wrong, Validation failed", message: Message }));
                    yield put(setValidationStatus({ successfullyAddedPayers: parseInt(totalRecord), payersWithErrors: errorCount, success: status, isTaxIdError: false }))
                } else {
                    yield put(setValidationStatus({ successfullyAddedPayers: parseInt(totalRecord), payersWithErrors: errorCount, success: status, isTaxIdError: false }))
                }
            }else{
                /* In case Data is not present, it means the it is missing Payer Tax ID & we don't get the count of Successfully Added Payers and Payer With Errors.
                In this case users won't be allowed to download the error report. */
                yield put(setValidationStatus({ successfullyAddedPayers: 0, payersWithErrors: 0, success: false, isTaxIdError: true }))
            }
        }

    } catch (error) {
        yield put(addNotifications({ heading: "Validation Failed", message: error?.response?.data?.Message }));
    } finally {
        yield put(setUploadedFile(null))
        yield put(setLoadingState({ state:ADD_PAYER_LOADING_STATES.VALIDATE_SHEET_RECORD_READY }))
    }

}

function* downloadErroReportAsync(action) {

    try {
        const response = yield PayerDataService.getErrorReport();

        if (response?.data.Status) {
            const { Base64, Name } = response?.data?.Data;
            General.downloadFile(Base64, Name)
        } else {
            yield put(addNotifications({ heading: "Something went wrong, failed to download an error report", message: response?.data?.Message }));
        }

    } catch (error) {
        yield put(addNotifications({ heading: "Failed to donwload an error report", message: error?.response?.data?.Message }));
    }

}

function* rootSaga() {
    yield all([
        takeLeading(getTemplate().type, getTemplateAsync),
        takeLeading(uploadSheet().type, uploadSheetAsync),
        takeLeading(validateSheetRecords().type, validateSheetRecordsAsync),
        takeLeading(downloadErroReport().type, downloadErroReportAsync),
    ]);
}
store.sagaManager.addSaga(componentKey, rootSaga);